import { isNil } from "lodash";

import getFreeGifts from "@helpers/items/getFreeGifts";
import getProductDefaultConfiguration from "@helpers/products/getProductDefaultConfiguration";

import type { Product } from "@typings/product/product";

export const refreshGifts = (cartItems: Product[]) => {
  const gifts = getFreeGifts().map((item) => ({
    item,
    configuration: getProductDefaultConfiguration(item),
  }));

  const total = cartItems.reduce(
    (acc, { configuration }) => acc + configuration.price * configuration.quantity,
    0
  );
  const hasSubscriptionItem = cartItems.some(
    (ci) => ci.configuration.offer.name === "Monthly Subscription"
  );

  const existingGifts = cartItems.filter((ci) => ci.item.category.name === "Free Gift");
  const nonGiftItems = cartItems.filter((ci) => ci.item.category.name !== "Free Gift");

  const validExistingGifts = existingGifts.filter((existingGift) => {
    const { from } = existingGift.item.additionalDetails;

    if (isNil(from)) return false;

    if (from === 0) {
      const threshold = hasSubscriptionItem ? 0 : 40;

      return total >= threshold;
    }

    return total >= from;
  });

  const giftsToAdd = gifts
    .filter((gift) => {
      const { from } = gift.item.additionalDetails;

      if (isNil(from)) return false;

      const alreadyHasGift = validExistingGifts.some(
        (existingGift) => existingGift.item.id === gift.item.id
      );

      if (alreadyHasGift) return false;

      if (from === 0) {
        const threshold = hasSubscriptionItem ? 0 : 40;

        return total >= threshold;
      }

      if (from > total) return false;

      return true;
    })
    .map((g) => g);

  const sortedGifts = giftsToAdd.sort((a, b) => {
    const giftOrder = {
      "Free Joint Care Treats": 1,
      "Free Calming Dog Blanket": 2,
      "Free Calming Dog Bed": 3,
    };

    const aOrder = giftOrder[a.item.name as keyof typeof giftOrder];
    const bOrder = giftOrder[b.item.name as keyof typeof giftOrder];

    return aOrder - bOrder;
  });

  return [...nonGiftItems, ...validExistingGifts, ...sortedGifts];
};
